import React from "react";
import QRCode from "react-qr-code";
import { Box } from "@mui/material";

const UpiQr = ({ url }) => (
  <Box display="flex" justifyContent="center" alignItems="center" p={2}>
    <QRCode
      size={190}
      style={{ height: "auto", maxWidth: "100%", width: "100%" }}
      value={url}
      viewBox="0 0 256 256"
    />
  </Box>
);

export default UpiQr;
